export default __webpack_public_path__ + "static/media/ServicenowLogo.3fa1bbe3.png";